import React from "react";
import classNames from "classnames";
import Link from "next/link";

interface ITextLink {
  href?: string | null;
  text?: string | null;
  className?: string;
  target?: string;
  children?: React.ReactNode;
}

export function TextLink({
  href,
  text = "",
  className = "",
  target = "_self",
  children,
}: ITextLink): JSX.Element {
  return (
    <Link
      href={href || ""}
      prefetch={false}
      className={classNames({
        "hover:text-gray-400 text-base prose": !Boolean(className),
        [className]: Boolean(className),
      })}
      target={target}
    >
      {children || text}
    </Link>
  );
}
